import Tooltip from 'tooltip.js';
import {getHeight, nodeToString} from "../../js/core/Helpers/Helpers";
import EmblemChooser from '../emblemChooser/emblemChooser';
import UpdatePrice from './priceUpdater';
import AddToCart from './addToCart';
import EditorActions from './editorActions';
import axios from 'axios';

const ProductDetails = () => {
	
	let expandables = document.getElementsByClassName('js-expandable');
	let expandBtns = document.getElementsByClassName('js-expand');
	let closables = document.getElementsByClassName('modal-closable');
	let customTextEditor = document.querySelector('#js-custom-text');
	let priceCompoundsClickable = document.getElementsByClassName('js-price-compound-clickable');
	let downloadableEngravingTemplates = document.getElementById('js-downloadable-engravings');
	let addToFav = document.getElementById('js-add-to-fav');
	let addToFavContainer = document.getElementById('js-add-to-fav-container');
	
	const handleChangeEngraving = element => {
		let parent = element.closest('.js-expandable');
		
		if (parent) {
			let btn = document.querySelector('#js-sketch-download');
			let priceCompound = parent.querySelector('.js-engravement-price');
			
			priceCompound.dataset.price = element[element.selectedIndex].dataset.price;
			
			if (btn) {
				let linkContainer = document.querySelector('#js-download-link');
				let file = element[element.selectedIndex].dataset.file;
				
				const updateBtnLink = () => {
					btn.classList.remove('hidden');
					linkContainer.href = file;
				}
				
				file && file !== ''
					? updateBtnLink()
					: btn.classList.add('hidden');
			}
			
			UpdatePrice();
		}
	};
	
	const initPopper = () => {
		let reference = document.getElementById('insc-popper-wrapper');
		if (reference) {
			let popperInstance = new Tooltip(reference, {
				placement: 'top',
				title: document.getElementById('insc-popper').innerText,
				trigger: 'hover'
			});
		}
		
		if (downloadableEngravingTemplates) {
			let items = downloadableEngravingTemplates.querySelectorAll(':scope .js-engraving-item');
			if (items.length == 0) {
				downloadableEngravingTemplates.remove();
			}
		}
	};
	
	const toggleShrunk = expandable => {
		let parent = expandable.closest('.js-expand-parent');
		let isShrunk = expandable.classList.contains('shrunk');
		
		if (isShrunk) {
			[...expandable.getElementsByClassName('js-price-compound-inactive')].map(price => {
				price.classList.add('js-price-compound');
				price.classList.remove('js-price-compound-inactive');
			});
		} else {
			[...expandable.getElementsByClassName('js-price-compound')].map(price => {
				price.classList.add('js-price-compound-inactive');
				price.classList.remove('js-price-compound');
			});
		}
		
		let height = isShrunk
			? expandable.dataset.height
			: 0;
		
		expandable.removeAttribute('style');
		expandable.setAttribute("style", "height:" + height + "px;");
		expandable.classList.toggle('shrunk');
		setTimeout(() => {
			expandable.removeAttribute('style');
		}, 300);
		
		let engravingVariantId = Array.from(document.querySelectorAll('select.js-engraving-variantId'));
		if (engravingVariantId && engravingVariantId.length) {
			engravingVariantId.forEach(engravingVariant => {
				handleChangeEngraving(engravingVariant);
			});
		}
		
		UpdatePrice();
	};
	
	const expand = e => {
		let parent = e.currentTarget.closest('.js-expand-parent');
		let expandable = parent.getElementsByClassName('js-expandable')[0];
		
		if (expandable.dataset.radio) {
			// if clicked element is visible then hide it
			// if clicked element is hidden and another is visible hide another and show current
			
			let elements = Array.from(document.querySelectorAll(`.js-expandable[data-radio="${expandable.dataset.radio}"]`));
			
			elements.forEach(element => {
				let shrunken = element.classList.contains('shrunk');
				if (element !== expandable || shrunken) {
					let elParent = element.closest('.js-expand-parent');
					let elCbx = elParent.querySelector('.css-checkbox');
					
					if (!element.classList.contains('shrunk')) {
						element.classList.add('shrunk');
						
						[...element.getElementsByClassName('js-price-compound')].map(price => {
							price.classList.add('js-price-compound-inactive');
							price.classList.remove('js-price-compound');
						});
					}
					
					elCbx.checked = false;
				}
				
				
			});
		}
		
		toggleShrunk(expandable);
	};
	
	[...expandables].map(box => {
		box.dataset.height = getHeight(box) + 6;
		box.classList.toggle('shrunk');
	});
	
	[...expandBtns].map(btn => {
		let parent = btn.closest('.js-expand-parent');
		let expandable = parent.querySelector('.js-expandable');
		let cbx = parent.querySelector('.css-checkbox');
		btn.addEventListener('click', e => expand(e));
		
		if (cbx.checked) {
			toggleShrunk(expandable);
		}
	});
	
	let additionalOpener = document.querySelector('#js-open-additional');
	if (additionalOpener) {
		additionalOpener.addEventListener('click', e => {
			e.currentTarget.classList.toggle('active');
			document.querySelector("#js-additional").classList.toggle('active')
		});
	}
	
	[...closables].map(close => close.addEventListener('click', () => {
		Array.from(document.getElementsByClassName('closable')).map(modal => modal.classList.remove('opened'));
	}));
	
	[...priceCompoundsClickable].map(elem => elem.addEventListener('click', () => {
		elem.classList.toggle('js-price-compound');
		UpdatePrice();
	}));
	
	let engravingVariantId = Array.from(document.querySelectorAll('select.js-engraving-variantId'));
	
	if (engravingVariantId && engravingVariantId.length) {
		engravingVariantId.forEach(engravingVariant => {
			engravingVariant.addEventListener('change', e => {
				let t = e.currentTarget;
				handleChangeEngraving(t);
			});
		});
		
	}
	
	document.querySelector("#js-add-to-cart-main").addEventListener('click', e => {
		e.preventDefault();
		AddToCart();
	});
	
	const initResetButtons = () => {
		// console.log('initResetButtons');
		let selectInputEnablers = document.getElementsByClassName('js-select-closer');
		if (selectInputEnablers.length > 0) {
			[...selectInputEnablers].map(enabler => enabler.addEventListener('click', () => {
				// console.log(enabler.parentElement.getElementsByClassName('js-product-parameter')[0]);
				enabler.parentElement.classList.remove('selected');
				enabler.parentElement.getElementsByTagName('select')[0].value = '';
				$('.selectpicker').selectpicker('refresh');
				/* TODO trigger select change event */
				parameterChangeHandler();
			}));
		}
	};
	
	function parameterChangeHandler() {
		let parametersContainer = $("#js-product-parameters");
		
		let form = parametersContainer.find("form");
		let priceUrl = parametersContainer.data('priceurl');
		let paramUrl = parametersContainer.data('paramurl');
		
		if (form.length) {
			let fd = new FormData(form[0]);
			
			let paramAjax = $.ajax({
				url: paramUrl,
				data: fd,
				processData: false,
				contentType: false,
				type: "post",
			});
			
			paramAjax.then(function (response) {
				parametersContainer.html(response);
				$('.selectpicker').selectpicker('refresh');
				onParameterChange();
				initResetButtons();
				
				
				let priceAjax = $.ajax({
					url: priceUrl,
					data: fd,
					processData: false,
					contentType: false,
					type: "post",
				});
				
				priceAjax.then(function (data) {
					$('#js-main-product-price').attr('data-price', data.currentPriceClean).text(data.currentPrice);
					if (data.oldPrice) {
						$('#js-main-product-price-old').text(data.oldPrice);
					}
					if (data.variantId) {
						$('#js-variantId').val(data.variantId);
					}
					UpdatePrice();
				});
			});
		}
	}
	
	function variantChangeHandler() {
		let variantsContainer = $("#js-product-variant");
		
		let form = variantsContainer.find("form");
		let priceUrl = variantsContainer.data('priceurl');
		
		if (form.length) {
			let fd = new FormData(form[0]);
			
			let priceAjax = $.ajax({
				url: priceUrl,
				data: fd,
				processData: false,
				contentType: false,
				type: "post",
			});
			
			priceAjax.then(function (data) {
				$('#js-main-product-price').attr('data-price', data.currentPriceClean).text(data.currentPrice);
				if (data.oldPrice) {
					$('#js-main-product-price-old').text(data.oldPrice).show();
				} else {
					$('#js-main-product-price-old').hide();
				}
				if (data.variantId) {
					$('#js-variantId').val(data.variantId);
				}
				UpdatePrice();
			});
		}
	}
	
	const onParameterChange = () => {
		let parametersContainer = $("#js-product-parameters");
		let selects = parametersContainer.find('.js-product-parameter');
		selects.each(function (i, item) {
			let element = $(item);
			
			element.on("change", parameterChangeHandler);
		});
	};
	
	const onVariantChange = () => {
		let variantSelect = $("#js-product-variant-selector");
		variantSelect.on("change", variantChangeHandler);
	}
	
	const handleAddToCartDetails = () => {
		$(document).on('click', '#js-show-add-to-cart-details', function (e) {
			e.preventDefault();
			$($(this).data('target')).slideToggle(300);
		});
	}
	
	const closeCartPopup = () => {
		$(document).on('click', '.js-close-cart-info', function (e) {
			e.preventDefault();
			$('#add-to-cart-popup').fadeOut(300, function () {
				$(this).remove();
				$('#js-cart-loader').remove();
				
				clearDesignForms();
			});
			clearDesignForms();
		});
	}
	
	const clearDesignForms = () => {
		let items = document.querySelectorAll('.js-remove-designed-product');
		items.forEach(link => {
			link.dataset.svg = '#';
			link.dataset.png = '#';
		});
		
		let previews = document.querySelectorAll('.js-designer-preview');
		previews.forEach(link => {
			link.href = '#';
		})
		
		let inputs = document.querySelectorAll('.js-custom-inscription');
		inputs.forEach(input => {
			input.value = '';
		})
		
		let images = document.querySelectorAll('.js-designer-preview-image');
		images.forEach(image => {
			image.src = '';
			image.classList.add('hidden');
		})
		
		let designers = document.querySelectorAll('.js-designer');
		designers.forEach(designer => {
			designer.classList.remove('hidden');
		})
		
		let containers = document.querySelectorAll('.js-engraving-controls');
		containers.forEach(container => {
			container.classList.add('hidden');
		})
		
		// let customDesigns = document.querySelectorAll('.filesInput__list__item__remove a');
		// customDesigns.forEach(customDesign => {
		// 	customDesign.closest('.filesInput__list__item').remove();
		// })
	}
	
	const designer = () => {
		$(document).on("click", '#js-designer', function (e) {
			e.preventDefault();
			
			let designer = $.ajax({
				'type': 'get',
				'url': 'designer'
			});
			
			designer.then(function (response) {
				console.log(response);
			});
		});
	};
	
	const handleCustomFiles = () => {
		let container = document.getElementById('js-custom-files');
		let fileList = document.getElementById('js-custom-files-list');
		let validTypes = [
			'application/pdf',
			'application/zip',
			'image/bmp',
			'image/jpeg',
			'image/png',
			'image/tiff',
		];
		
		if (container) {
			let customFile = document.getElementById('js-custom-file');
			
			if (customFile) {
				customFile.addEventListener('change', e => {
					// clear all files
					fileList.innerHTML = "";
					
					let self = e.currentTarget;
					let files = Array.from(self.files);
					
					files.forEach(file => {
						let name = file.name;
						let type = file.type;
						
						if (validTypes.indexOf(type) === -1) {
							console.warn(`File ${name} is not valid file (not supported extension).`);
							customFile.value = "";
							return false;
						} else {
							let template = document.createElement('div');
							let isImage = type.indexOf('image/') !== -1;
							let labelGridSize = 12;
							let imagePreview = new Promise((resolve, reject) => {
								if (isImage) {
									labelGridSize = 8;
									let image = new Image();
									let reader = new FileReader();
									
									image.classList.add('flex-xs-12', 'flex-sm-4', 'filesInput__list__item__image', 'img-responsive');
									
									reader.onload = e => {
										image.src = e.target.result;
										resolve(nodeToString(image));
									};
									
									reader.readAsDataURL(file);
								} else {
									resolve('');
								}
							});
							
							imagePreview.then(result => {
								let remove = document.createElement('a');
								remove.setAttribute('href', '#');
								remove.innerHTML = `<i class="fa fa-times"></i>`;
								remove.addEventListener('click', e => {
									e.preventDefault();
									let t = e.currentTarget;
									
									t.closest('.filesInput__list__item').remove();
								});
								
								template.classList.add('flex-row', 'filesInput__list__item');
								template.innerHTML = `
									${result}
									<div class="flex-xs-12 flex-sm-${labelGridSize} vcenter">
										<div class="filesInput__list__item__label">
											<span class="filesInput__list__item__remove">
												${name}
											</span>
										</div>
									</div>
								`;
								
								template.querySelector('.filesInput__list__item__remove').prepend(remove);
								
								fileList.appendChild(template);
							});
							
						}
					});
				});
			}
		}
		
	};
	
	const addToFavHandler = () => {
		if (addToFav) {
			addToFav.addEventListener('click', function (e) {
				e.preventDefault();
				axios.get(addToFav.dataset['href']).then(response => {
					if (response.data.status == 'success') {
						if (response.data.action == 'add') {
							addToFavContainer.classList.add('active');
						} else {
							addToFavContainer.classList.remove('active');
						}
					}
				});
			});
		}
	}
	
	initPopper();
	// onParameterChange();
	onVariantChange();
	initResetButtons();
	handleAddToCartDetails();
	closeCartPopup();
	addToFavHandler();
	EmblemChooser({
		updatePrice: UpdatePrice
	});
	
	designer();
	handleCustomFiles();
	
	if (customTextEditor) {
		EditorActions(customTextEditor);
	}
	
	// parameterChangeHandler();
};

export default ProductDetails;


// WEBPACK FOOTER //
// ./components/productDetails/productDetails.js